// Lightweight IndexedDB store for photo blobs so drafts survive a page refresh
// WITHOUT uploading images to any external provider.
const DB_NAME = "rep_video_creator";
const STORE = "photos";

function openDb() {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB_NAME, 1);
    req.onupgradeneeded = () => {
      const db = req.result;
      if (!db.objectStoreNames.contains(STORE)) db.createObjectStore(STORE);
    };
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

function tx(mode) {
  return openDb().then((db) => db.transaction(STORE, mode).objectStore(STORE));
}

const keyFor = (projectId, imageId) => `${projectId}:${imageId}`;

export async function putPhoto(projectId, imageId, blob) {
  const store = await tx("readwrite");
  return new Promise((resolve, reject) => {
    const r = store.put(blob, keyFor(projectId, imageId));
    r.onsuccess = () => resolve(true);
    r.onerror = () => reject(r.error);
  });
}

export async function getPhoto(projectId, imageId) {
  const store = await tx("readonly");
  return new Promise((resolve, reject) => {
    const r = store.get(keyFor(projectId, imageId));
    r.onsuccess = () => resolve(r.result || null);
    r.onerror = () => reject(r.error);
  });
}

export async function deletePhoto(projectId, imageId) {
  const store = await tx("readwrite");
  return new Promise((resolve) => {
    const r = store.delete(keyFor(projectId, imageId));
    r.onsuccess = () => resolve(true);
    r.onerror = () => resolve(false);
  });
}
